import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {useLocation} from 'react-router-dom'
import { socialLogin } from '../store/reducer/userSlice'

const SocialLoginSuccess = () => {
    const dispatch = useDispatch()
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery()
    const token = query.get('token')

    useEffect(() => {
        (async () => await dispatch(socialLogin(token)))()
        window.close()
    },[dispatch, token])

    return (
        <div>
        </div>
    )
}

export default SocialLoginSuccess
